export enum BoardStateSource {
  ReduxStore = 'redux-store',
  BOARD_DATA_FETCHER = 'BOARD DATA FETCHER',
}
